import { render, staticRenderFns } from "./SendRegistrar.vue?vue&type=template&id=6108bad2&scoped=true&"
import script from "./SendRegistrar.vue?vue&type=script&lang=js&"
export * from "./SendRegistrar.vue?vue&type=script&lang=js&"
import style0 from "./SendRegistrar.vue?vue&type=style&index=0&id=6108bad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6108bad2",
  null
  
)

export default component.exports